import React, { useState, useRef, useEffect } from 'react';
import './DownloadDropdown.css';

const DOWNLOADS = [
  { label: 'Modrinth', url: 'https://modrinth.com/mod/petlings' },
  { label: 'CurseForge', url: 'https://www.curseforge.com/minecraft/mc-mods/petlings' },
];

export default function DownloadDropdown({ className, children, menuAlign = 'left' }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="download-dropdown" ref={wrapRef}>
      <button
        type="button"
        className={`download-dropdown-trigger ${className || ''}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {children}
      </button>
      {open && (
        <ul className={`download-dropdown-menu menu-${menuAlign}`} role="menu">
          {DOWNLOADS.map((d) => (
            <li key={d.url} role="none">
              <a
                role="menuitem"
                href={d.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
              >
                {d.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
